let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2fcuy")).then(() => parcelRequire('8VBAo'));